/* eslint-disable max-len */
export const DE_CONTENT = {
	consentModal: {
		title:
			"Cookie Dashboard <img style='width: 50px;float: right;' src='https://cdn.shopify.com/s/files/1/0228/6528/1104/files/LOGOWEBISTE.png?v=1714047779'/>",
		description: `Wenn du auf „Zustimmen" klickst, bist du damit einverstanden, dass wir deine Nutzung unserer Plattform über Cookies (von Every. und Drittanbietern) verfolgen. Das machen wir, um dein Nutzererlebnis und die angezeigten Werbeanzeigen zu analysieren und zu personalisieren, und auch für die <strong>Personalisierung von Anzeigen</strong>. Mehr darüber, wie Google deine Daten verwendet, findest du unter <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Googles Sicherheit und Datenschutz für Unternehmen</a>.
    
    <div class="cc-custom-list-type"><p>Essentiell</p><p>Statistik</p><p>Marketing</p></div>
    `,
		acceptAllBtn: "Einverstanden",
		showPreferencesBtn: "Einstellungen anpassen",
		acceptNecessaryBtn: "Alle ablehnen",
	},
	preferencesModal: {
		title: "Cookie dashboard",
		savePreferencesBtn: "Speichern & schließen",
		acceptAllBtn: "Alle akzeptieren",
		acceptNecessaryBtn: "Alle ablehnen",
		closeIconLabel: "Close",
		sections: [
			{
				title: "",
				description: `Wenn du auf „Zustimmen" klickst, bist du damit einverstanden, dass wir deine Nutzung unserer Plattform über Cookies (von Every. und Drittanbietern) verfolgen. Das machen wir, um dein Nutzererlebnis und die angezeigten Werbeanzeigen zu analysieren und zu personalisieren, und auch für die <strong>Personalisierung von Anzeigen</strong>. Mehr darüber, wie Google deine Daten verwendet, findest du unter <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Googles Sicherheit und Datenschutz für Unternehmen</a>.`,
			},
			{
				title: "Essential",
				description:
					"Diese Cookies braucht Every, um als Website zu funktionieren. Deshalb können sie auch nicht abgeschaltet werden – ohne Basiscookies geht hier schlichtweg nichts. Sie sorgen dafür, dass Du auf Every sicher und bequem unterwegs bist.",
				linkedCategory: "necessary",
			},
			{
				title: "Statistik",
				description:
					"Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
				linkedCategory: "analytics_storage",
			},
			{
				title: "Marketing",
				description:
					"Diese Cookies geben uns wichtige Hinweise zum Verhalten unserer Besucher. Sie sammeln Informationen darüber, was User auf Every am meisten interessiert oder welche Seiten am häufigsten genutzt werden. So können wir Every auf die Bedürfnisse unserer Kunden ausrichten. Auch diese Daten erheben wir anonym. Wir wollen Dir nur Anzeigen präsentieren, die Dich auch interessieren. Deshalb verwenden wir Cookies, die Deine Suchkriterien erfassen und dafür sorgen, dass Du auf Facebook oder Google Bowls siehst, die zu Dir passen.",
				linkedCategory: "ad_storage",
			},
			{
				title: "Mehr Informationen",
				description: `Bei Fragen zu unserer Richtlinie zu Cookies und Ihren Auswahlmöglichkeiten wenden Sie sich bitte an <a class="cc-link" href="/faq">kontaktiere uns</a>.`,
			},
		],
	},
};

export const EN_CONTENT = {
	consentModal: {
		title:
			"Cookie Dashboard <img style='width: 50px;float: right;' src='https://cdn.shopify.com/s/files/1/0228/6528/1104/files/LOGOWEBISTE.png?v=1714047779'/>",
		description: `By clicking "agree", you agree that we may track your use of our platform through cookies (from Every. and third parties) to analyze and personalize your user experience, and for <strong>ads personalization</strong>. Learn more about how Google uses your data at <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Google's business safety & privacy</a>.
		<div class="cc-custom-list-type"><p>Essential</p><p>Statistics</p><p>Marketing</p></div>
		`,
		acceptAllBtn: "Accept all",
		acceptNecessaryBtn: "Reject all",
		showPreferencesBtn: "Change settings",
	},
	preferencesModal: {
		title: "Cookie dashboard",
		savePreferencesBtn: "Save current preferences",
		acceptAllBtn: "Accept all",
		acceptNecessaryBtn: "Reject all",
		closeIconLabel: "Close",
		sections: [
			{
				title: "",
				description: `By clicking "agree", you agree that we may track your use of our platform through cookies (from Every. and third parties) to analyze and personalize your user experience, and for <strong>ads personalization</strong>. Learn more about how Google uses your data at <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Google's business safety & privacy</a>.`,
			},
			{
				title: "Essential",
				description:
					"Every. needs these cookies to function as a website. That's why they can't be turned off - without basic cookies, nothing works here. They ensure that you are safe and comfortable on Every.",
				linkedCategory: "necessary",
			},
			{
				title: "Statistics",
				description:
					"Statistics cookies help website owners understand how visitors interact with websites by collecting and reporting information anonymously.",
				linkedCategory: "analytics_storage",
			},
			{
				title: "Marketing",
				description:
					"These cookies give us important information about the behavior of our visitors. They collect information about what interests users the most on Every or which pages are used most frequently. This allows us to tailor Every to the needs of our customers. We also collect this data anonymously. We only want to show you ads that are of interest to you. That's why we use cookies that record your search criteria and ensure that you see bowls that are relevant to you on Facebook or Google.",
				linkedCategory: "ad_storage",
			},
			{
				title: "More information",
				description: `For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/en/faq">contact us</a>.`,
			},
		],
	},
};

export const NL_CONTENT = {
	consentModal: {
		title:
			"Cookie Dashboard <img style='width: 50px;float: right;' src='https://cdn.shopify.com/s/files/1/0228/6528/1104/files/LOGOWEBISTE.png?v=1714047779'/>",
		description: `Als je op "Akkoord" klikt, ga je ermee akkoord dat we je gebruik van ons platform volgen met cookies (van Every. en derden). Dit doen we om je gebruikerservaring en de advertenties die je ziet te analyseren en persoonlijker te maken, en ook voor <strong>persoonlijke advertenties</strong>. Meer weten over hoe Google je gegevens gebruikt? Kijk dan op <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Google's bedrijfsveiligheid en privacy</a>.
		<div class="cc-custom-list-type"><p>Essentieel</p><p>Statistieken</p><p>Marketing</p></div>
		`,
		acceptAllBtn: "Alles accepteren",
		showPreferencesBtn: "Instellingen aanpassen",
		acceptNecessaryBtn: "Alles afwijzen",
	},
	preferencesModal: {
		title: "Cookie Dashboard",
		savePreferencesBtn: "Huidige voorkeuren opslaan",
		acceptAllBtn: "Accepteer alles",
		acceptNecessaryBtn: "Alles afwijzen",
		closeIconLabel: "Close",
		sections: [
			{
				title: "",
				description: `Als je op "Akkoord" klikt, ga je ermee akkoord dat we je gebruik van ons platform volgen met cookies (van Every. en derden). Dit doen we om je gebruikerservaring en de advertenties die je ziet te analyseren en persoonlijker te maken, en ook voor <strong>persoonlijke advertenties</strong>. Meer weten over hoe Google je gegevens gebruikt? Kijk dan op <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Google's bedrijfsveiligheid en privacy</a>.`,
			},
			{
				title: "Essentieel",
				description:
					"Every. heeft deze cookies nodig om te functioneren als een website. Daarom kunnen ze niet worden uitgeschakeld - zonder basiscookies werkt hier niets. Ze zorgen ervoor dat je veilig en comfortabel bent op Every.",
				linkedCategory: "necessary",
			},
			{
				title: "Statistieken",
				description:
					"Cookies voor statistieken helpen website-eigenaren te begrijpen hoe bezoekers omgaan met websites door informatie anoniem te verzamelen en te rapporteren.",
				linkedCategory: "analytics_storage",
			},
			{
				title: "Marketing",
				description:
					"Deze cookies geven ons belangrijke informatie over het gedrag van onze bezoekers. Ze verzamelen informatie over wat gebruikers het meest interesseert op Every of welke pagina's het meest worden gebruikt. Hierdoor kunnen we Every aanpassen aan de behoeften van onze klanten. We verzamelen deze gegevens ook anoniem. We willen je alleen advertenties laten zien die voor jou interessant zijn. Daarom gebruiken we cookies die je zoekcriteria registreren en ervoor zorgen dat je op Facebook of Google kommetjes ziet die relevant zijn voor jou.",
				linkedCategory: "ad_storage",
			},
			{
				title: "Meer informatie",
				description: `Voor vragen over ons cookiebeleid en je keuzes, <a class="cc-link" href="/faq">neem contact met ons op</a>.`,
			},
		],
	},
};